export const MAX_INPUT_VALUE = 99999999;
